import { render, staticRenderFns } from "./SyncTypeNavBar.vue?vue&type=template&id=1d4abded&scoped=true&"
import script from "./SyncTypeNavBar.vue?vue&type=script&lang=js&"
export * from "./SyncTypeNavBar.vue?vue&type=script&lang=js&"
import style0 from "./SyncTypeNavBar.vue?vue&type=style&index=0&id=1d4abded&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4abded",
  null
  
)

export default component.exports